import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import { fullMonths, shortMonths } from '../../../../helpers/localization/localizationUtils';
import Box from '../../../elements/Box';
import Text from '../../../elements/Text';

const Caption = (props) => {
  const { date, monthSettings, yearSettigs, captionContainer, yearDisplay } = props;
  const { translate, direction, localizationData } = useContext(Context);
  const month =
    monthSettings && monthSettings.showFullMonth
      ? fullMonths(translate, localizationData)[date.getMonth()]
      : shortMonths(translate, localizationData)[date.getMonth()];
  const style = { lineHeight: 0.9 }; // TODO: search for other solutions in order to avoid using 'lineHeight'
  const showYear = yearDisplay === 'new-year' ? date.getMonth() === 0 : true;

  return (
    <Box className="DayPicker-Caption" dataTestId="datePickerCaption">
      <Box tabIndex={0} style={style} {...captionContainer} direction={direction}>
        <Text {...monthSettings}>{month}</Text>
        {showYear && <Text {...yearSettigs}>{date.getFullYear()}</Text>}
      </Box>
    </Box>
  );
};
Caption.propTypes = {
  captionContainer: PropTypes.objectOf(PropTypes.any),
  monthSettings: PropTypes.objectOf(PropTypes.any),
  yearSettigs: PropTypes.objectOf(PropTypes.any),
  className: PropTypes.string,
  date: PropTypes.objectOf(PropTypes.any).isRequired,
  /**
   * Font size on the componet
   */
  fontSize: PropTypes.string,
  /**
   * Text align props
   */
  textAlign: PropTypes.string,
  translate: PropTypes.func,
  yearDisplay: PropTypes.oneOf(['new-year', 'always'])
};

Caption.defaultProps = {
  captionContainer: {
    display: 'flex',
    justifyContent: 'between',
    width: '100',
    alignItems: 'end',
    paddingHeight: '3'
  },
  monthSettings: {
    fontSize: '8',
    fontWeight: 'bold'
  },
  yearSettigs: {
    fontSize: '4',
    fontWeight: 'bold'
  },
  yearDisplay: 'new-year',
  className: '',
  fontSize: '4',
  textAlign: 'center',
  translate: () => {}
};
export default Caption;
